var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"log-panel"},[_c('div',{staticClass:"log-panel-shadow",class:{
         'shadow-top': !_vm.atTop && _vm.atBottom,
         'shadow-bottom': _vm.atTop && !_vm.atBottom,
         'shadow-top-bottom': !_vm.atTop && !_vm.atBottom}}),_c('a',{staticClass:"copy-text-button btn-floating btn-flat waves-effect",on:{"click":_vm.copyLogToClipboard}},[_c('i',{staticClass:"material-icons"},[_vm._v("content_copy")])])])}
var staticRenderFns = []

export { render, staticRenderFns }